import React, {Component} from 'react';
import $ from 'jquery';
import { Link, browserHistory } from 'react-router';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class WebFooter extends Component{
	constructor(props){
		super(props);
		this.state={
			email:'',
		    phone:'',
		    timings:'',
		}
		this.getCustomerCareDetails=this.getCustomerCareDetails.bind(this);
	}
	componentDidMount()
	{
		this.getCustomerCareDetails();
	}
	getCustomerCareDetails()
	{
		var data1={from:'desktop_web',};
		var data2=JSON.stringify(data1);
		$.ajax({
		    method: 'POST',
		    url: baseUrl+'getCustomerSupportDetails',
		    dataType:'json',
		    data: {req:data2},
		    success: function(data)
		    {
		        this.setState({
		            email:data.email,
		            timings: data.timings,
		            phone: data.phone,
		        });
		    }.bind(this),
		    error: function(err)
		    {
		        
		  	}
		});
	}
	render()
	{
		return(
			<footer className="ad_foter">
				<div style={{position:'relative',width:'100%'}}>
				  <div className="container">

				  	<div className="col-md-3 col-sm-3"> <img src={baseAssets+'images_web/customer_care_bg.png'} alt=" " className="cstmr_care_bg" /> </div>

				    <div className="col-md-2 col-sm-2 fotr_cstmr_care" style={{listStyle:'none'}}>		    
				       
				          <ul>
				          	<li style={{overflow:'hidden', paddingBottom:'8px', marginBottom:'5px'}}> <h4 className="web_blk_titles"> Useful Links </h4> </li>
				          	<li> <a href="http://miledeepworks.in" target="_blank" title=""> About Us </a> </li>
				          	<li> <a href="http://blog.aqua.deals" target="_blank" title=""> Our Blog </a> </li> 
				          	<li> <Link to={"web/customer_care"} title=""> Contact Us </Link> </li>
				          	<li> <Link to={"web/advertise-with-us"} title=""> Advertise with Us </Link> </li>
							<li> <Link to={"web/enquire_now/partner/support/sid/did"} title=""> Sell on AquaDeals </Link> </li>
				          </ul>				       
				 
				    </div>
				     <div className="col-md-3 col-sm-3 off_add fotr_cstmr_care">
				     		<ul style={{listStyle:'none',fontSize:'16px'}}> 
				     			<li style={{overflow:'hidden', listStyle:"none", paddingBottom:'8px', marginBottom:'5px'}}> <h4 className="web_blk_titles">Registered Office Address : </h4> </li>
				     			<li> <span>  A unit of Mile deep works Pvt. Ltd. </span> </li>
				     			<li> <span> Plot No.4, SKS Township, Ganganapalli, Kakinada, East Godavari, Andhra Pradesh, 533006 </span> </li>
				     			<li> <span> 8008765779 </span> </li>
				     			<li> <span> contactus@miledeepworks.com </span> </li>
				     		</ul>
				     </div>
				    <div className="col-md-4 col-sm-4 android_play">
				      <ul>
				      <li style={{overflow:'hidden', listStyle:"none", width:'100%', paddingBottom:'8px',clear: 'both', marginBottom:'5px'}}> <h4 className="web_blk_titles">Download App</h4> </li>
				       
				        <li><p>Download the Android app<br/>to get a much Smoother <br/> AquaDeals Experiance</p> <br/>
				        	<a href="https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en" target="_blank" className="and_play_btn">
				        	<img src={baseAssets+'images_web/android_play.png'} alt="" />
				        	</a>
				        </li>
				        </ul>
				    </div>				    				    
				  </div>
				{/*   <a href="#" className="ftr_close_btn"><img src={baseAssets+'images/footer_close_icons.png"></a> */}
				</div>
				</footer>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/WebFooter.js
 **/